<button class="toggle-password" (click)="onClick($event)" type="button">
  <img alt="Toggle Password" [src]="icon" width="20" height="20" />
</button>
